import React, {useEffect, useRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import {menuButton, textButton} from "../../../../utils/styles";
import clsx from "clsx";
import {KeyboardArrowDown} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import PropTypes from "prop-types";
import {useNavigate, useLocation} from "react-router-dom";
import SubMenuItem from "./SubMenuItem";

const useStyles = makeStyles(theme => ({
    paper: {
        maxWidth: 300,
        backgroundColor: theme.palette.primary.light,
        color: 'white'
    },
    ...menuButton(theme),
    ...textButton(theme, false)
}));

export default function MenuButtonMultipleLinks(props) {
    const {
        label,
        selected,
        icon,
        options,
        ...rest
    } = props;
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const menuRef = useRef();

    useEffect(() => {
        handleClose();
    }, [location]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = event => {
        setAnchorEl(null);
    };

    const handleSubMenuBackDropClick = event => {
        const rect = menuRef.current.querySelector('.MuiMenu-paper').getBoundingClientRect();

        const clickIsInMenu = event.clientX >= rect.left && event.clientX <= rect.right
            && event.clientY >= rect.top && event.clientY <= rect.bottom;

        if (!clickIsInMenu) {
            handleClose();
        }
    };

    const onClickMenuItem = to => () => {
        navigate(to);

        handleClose();
    };

    return (
        <>
            <Button
                className={clsx(classes.menuButton, selected && 'selected')}
                startIcon={icon}
                endIcon={<KeyboardArrowDown />}
                aria-controls={`${label}Label`}
                aria-haspopup="true"
                onClick={handleClick}
                {...rest}>
                {label}
            </Button>
            <Menu
                ref={menuRef}
                id={`${label}Menu`}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                transformOrigin={{ vertical: -50, horizontal: 'center' }}
                classes={{ paper: classes.paper }}>
                {options.map(option => !option.options ? (
                    <MenuItem
                        key={option.label}
                        onClick={option.onClick ? () => { option.onClick(); handleClose(); } : onClickMenuItem(option.to)}
                        disabled={option.disabled}>
                        {option.label}
                    </MenuItem>
                ) : (
                    <SubMenuItem
                        key={option.label}
                        label={option.label}
                        options={option.options}
                        onCloseParentMenu={handleClose}
                        onClickMenuBackdrop={handleSubMenuBackDropClick} />
                ))}
            </Menu>
        </>
    );
};

MenuButtonMultipleLinks.propTypes = {
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    icon: PropTypes.element,
    options: PropTypes.array.isRequired
};